<template>
  <div>
    <v-tabs
      :ripple="false"
      v-model="selectedTab"
      slider-color="dinamo"
      background-color="transparent"
      centered
      show-arrows
      mobile-break-point="100px"
    >
      <v-tab v-for="tab in tabs" :id="`tab_${tab.id}`" :key="`tab-${tab.id}`">
        {{ tab.title }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedTab">
      <v-tab-item class="mt-4">
        <v-row :key="1" no-gutters>
          <v-col cols="12">
            <app-top-blocks @tab="handleValueChanged" />
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item class="mt-4">
        <v-row :key="2" no-gutters>
          <v-col cols="12">
            <app-resources-panel />
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item class="mt-4">
        <app-sessions-list :start-with-block="start" />
      </v-tab-item>

      <v-tab-item class="mt-4">
        <app-events-list />
      </v-tab-item>

      <v-tab-item class="mt-4">
        <key-monitor />
      </v-tab-item>

      <v-tab-item class="mt-4">
        <object-monitor />
      </v-tab-item>

      <v-tab-item class="mt-4">
        <global-monitor-page />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import AppTopBlocks from './BlocksPanel'
import AppResourcesPanel from '@/components/AppResourcesPanel'
import AppSessionsList from '@/components/AppSessionsList'
import AppEventsList from '@/components/AppEventsList'
import GlobalMonitorPage from './GlobalMonitorPage.vue'
import KeyMonitor from './KeyMonitor.vue'
import ObjectMonitor from './ObjectMonitor.vue'

export default {
  components: {
    AppTopBlocks,
    AppResourcesPanel,
    AppSessionsList,
    AppEventsList,
    KeyMonitor,
    ObjectMonitor,
    GlobalMonitorPage
  },
  created () {
    if (this.parameterSelect !== undefined) {
      this.selectedTab = this.parameterSelect
    }
  },
  data () {
    return {
      selectedTab: 0,
      start: false
    }
  },
  computed: {
    tabs () {
      return [
        {
          title: this.$tc('general'),
          id: 'general'
        },
        {
          title: this.$tc('cpu_memory'),
          id: 'cpu_memory'
        },
        {
          title: this.$tc('session', 2),
          id: 'session'
        },
        {
          title: this.$tc('event', 2),
          id: 'event'
        },
        {
          title: this.$tc('crypto'),
          id: 'crypto_monitor'
        },
        {
          title: this.$tc('stats'),
          id: 'stats_monitor'
        },
        {
          title: this.$tc('global_monitor'),
          id: 'global_monitor'
        }
      ]
    },
    parameterSelect () {
      return this.$route.params.selectedTab
    }
  },
  methods: {
    handleValueChanged (value) {
      this.selectedTab = value
      this.start = true
    }
  }
}
</script>
<style>

.theme--light.v-tabs-items {
  background-color: transparent;
}
.theme--dark.v-tabs-items {
  background-color: transparent;
}

</style>
